import { render, staticRenderFns } from "./userInitialSignature.vue?vue&type=template&id=319573a4&scoped=true&"
import script from "./userInitialSignature.vue?vue&type=script&lang=ts&"
export * from "./userInitialSignature.vue?vue&type=script&lang=ts&"
import style0 from "./userInitialSignature.vue?vue&type=style&index=0&id=319573a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319573a4",
  null
  
)

export default component.exports